import { render, staticRenderFns } from "./academic_wordgroup_management.vue?vue&type=template&id=0a8284ac&"
import script from "./academic_wordgroup_management.vue?vue&type=script&lang=js&"
export * from "./academic_wordgroup_management.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports